const collapsedRailOuterClasses = 'flex-none w-[48px] h-full mx-2 pb-2';

/** Reserves the collapsed-column rail while the pipeline board loads. */
export const PipelineBoardRailSkeleton = () => (
  <div className={collapsedRailOuterClasses}>
    <div className="flex h-full w-full flex-col items-center rounded-xl border border-dashed border-secondary-200/80 bg-secondary-50/60 px-2 py-3 shadow-sm">
      <div className="h-7 w-7 rounded-md bg-secondary-200/70 animate-pulse" />
      <div className="mt-5 h-8 w-8 rounded-full bg-secondary-200/70 animate-pulse" />
      <div className="flex flex-1 items-center justify-center py-4">
        <div className="h-28 w-4 rounded-full bg-secondary-200/70 animate-pulse" />
      </div>
    </div>
  </div>
);
